import { TMonthlyFeeListItem } from 'redux/reducers/monthlyFee/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	ETableStructureVerticalAlign,
} from 'ui/EasTable/types';
import { EMonthlyFeeStatus } from 'redux/reducers/monthlyFee/constants';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructura = [
	{
		name: 'id',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
	},
	{
		name: 'EM Full Name',
		selector: 'emFullName',
		show: true,
		sortable: false,
		filterable: false,
		searchable: false,
		colSpan: 1,
		type: ETableStructureType.EM,
		value: (item: TMonthlyFeeListItem) => {
			return { id: item.emId, name: item.emFullName };
		},
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'EM ID',
		selector: 'emClientId',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'Current Monthly Fee',
		selector: 'currentMonthlyFee',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'New Monthly Fee',
		selector: 'newMonthlyFee',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'New EAS Fee Class',
		selector: 'newFeeClass',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'Requested At',
		selector: 'requestedAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'Created By',
		selector: 'createdBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'Effective Month',
		selector: 'effectiveMonth',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_MONTH,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'Status',
		selector: 'status',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		filter: [
			[EMonthlyFeeStatus.PENDING, EMonthlyFeeStatus.PENDING],
			[EMonthlyFeeStatus.APPLIED, EMonthlyFeeStatus.APPLIED],
			[EMonthlyFeeStatus.PROCESSING, EMonthlyFeeStatus.PROCESSING],
			[EMonthlyFeeStatus.CANCELED, EMonthlyFeeStatus.CANCELED],
		],
		colors: [
			[EMonthlyFeeStatus.PENDING, 'warning.light'],
			[EMonthlyFeeStatus.APPLIED, 'success.light'],
			[EMonthlyFeeStatus.PROCESSING, 'info.light'],
			[EMonthlyFeeStatus.CANCELED, 'error.light'],
		],
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		verticalAlign: ETableStructureVerticalAlign.TOP,
		buttons: [{ name: 'Receive' }, { name: 'Add Comment' }],
		buttonFilter: (item: TMonthlyFeeListItem) => {
			switch (item.status) {
				case EMonthlyFeeStatus.PENDING:
					return [{ name: 'Delete', color: 'error.main', icon: EIconButtons.DELETE }];
				default:
					return [];
			}
		},
	},
];
